// 9fbef606107a605d69c0edbcd8029e5d
import { STORE_DETAIL_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';
import { createSelector } from 'reselect';
import { fromJS } from 'immutable';
import isEmpty from 'lodash/isEmpty';
import { getDynamicLabelValues } from '../../../../../utils/labels/labelUtilty';

export const getCurrentStore = (state) => {
  return state[STORE_DETAIL_REDUCER_KEY].get('currentStore');
};

export const getCurrentStoreBasicInfo = createSelector(
  [getCurrentStore],
  (currentStoreState) =>
    currentStoreState && currentStoreState.size > 0 && currentStoreState.get('basicInfo')
);

export const formatHoursToObject = (storeHours) => {
  const formattedHrs = {};
  const formatHoursChild = (hoursToFormat) => {
    const returnedHours = [];
    hoursToFormat.forEach((hr, i) => {
      const tempIntObj = {};
      const tempIntObj2 = {};
      if (hoursToFormat.getIn([i, 'openIntervals']).size > 1) {
        hoursToFormat.getIn([i, 'openIntervals', 1])?.forEach((value, key) => {
          tempIntObj2[key] = value;
        });
      }
      hoursToFormat.getIn([i, 'openIntervals', 0])?.forEach((value, key) => {
        tempIntObj[key] = value;
      });
      returnedHours.push({
        dayName: hoursToFormat.getIn([i, 'dayName']),
        isClosed: hoursToFormat.getIn([i, 'isClosed']),
        openIntervals: isEmpty(tempIntObj2) ? [tempIntObj] : [tempIntObj, tempIntObj2],
      });
      return hr;
    });
    return returnedHours;
  };
  if (storeHours && storeHours.size > 0) {
    storeHours?.forEach((value, key) => {
      formattedHrs[key] = formatHoursChild(storeHours.get(key));
      return value;
    });
  }
  return formattedHrs;
};

export const formatGenericMapObject = (store) => {
  const resultObject = {};
  if (store && store.size > 0) {
    store.forEach((value, key) => {
      resultObject[key] = value;
      return value;
    });
  }
  return resultObject;
};

export const formatCurrentStoreToObject = (store) => {
  if (store && store.size > 0) {
    const formattedStore = {};
    const basicInfoState = store.get('basicInfo') || fromJS({});
    const isGym = store.get('isGym') || false;
    const addressState = basicInfoState.size > 0 && basicInfoState.get('address');
    const coordinateState = basicInfoState.size > 0 && basicInfoState.get('coordinates');
    const address = {};
    const coordinates = {};
    if (addressState.size > 0) {
      addressState.forEach((value, key) => {
        address[key] = value;
        return value;
      });
    }
    if (coordinateState.size > 0) {
      coordinateState.forEach((value, key) => {
        coordinates[key] = value;
        return value;
      });
    }
    formattedStore.basicInfo = {
      id: basicInfoState.get('id'),
      storeName: basicInfoState.get('storeName'),
      phone: basicInfoState.get('phone'),
      address,
      coordinates,
      storeDiscount: basicInfoState.get('storeDiscount'),
    };
    formattedStore.hours = formatHoursToObject(store.get('hours'));
    formattedStore.features = formatGenericMapObject(store.get('features'));
    formattedStore.isGym = isGym;
    return formattedStore;
  }
  return { ...store };
};

export const getNearByStores = (state) => state[STORE_DETAIL_REDUCER_KEY].get('suggestedStores');

export const getNearByStoresLoading = (state) =>
  state[STORE_DETAIL_REDUCER_KEY].get('isNearbyStoresLoading');

export const isFavoriteStore = (state) => {
  const defaultStore = state.User.get('defaultStore');
  const basicInfoDefaultStore = defaultStore && defaultStore.basicInfo;
  const currentStoreState = getCurrentStore(state);
  const basicInfoStore =
    currentStoreState && formatCurrentStoreToObject(currentStoreState).basicInfo;
  return (
    (basicInfoStore && basicInfoStore.id) === (basicInfoDefaultStore && basicInfoDefaultStore.id)
  );
};

export const getReferredContentList = () => {
  const labels = getDynamicLabelValues('StoreLocator');
  return labels?.StoreDetail?.referred ?? [];
};

export const getSeoData = (state) => {
  return state.SEOData && state.SEOData.store;
};

export const getStoreDetailLoadingState = (state) =>
  state[STORE_DETAIL_REDUCER_KEY].get('isStoreDetailLoading');

export const getRichTextContent = (state, key) => state[STORE_DETAIL_REDUCER_KEY].get(key);

export const getStoreSpecialProducts = (state) =>
  state[STORE_DETAIL_REDUCER_KEY].get('storeSpecialProducts');

export const getStoreSpecialProductsLoading = (state) => {
  const storeDetail = state[STORE_DETAIL_REDUCER_KEY];

  // Check if storeDetail exists
  if (!storeDetail) {
    return false; // or handle the case as needed
  }

  const isLoading = storeDetail.get('caraosalDataloading');
  const hasError = storeDetail.get('error');

  return isLoading && !hasError;
};
